<template>
  <div class="login">
    <div class="login-area">
      <h1><img src="../../public/static/mp_logo.png" alt="MailPublisherHTMLeditor" width="440" height="184"></h1>
      <div v-if="siteExistChecked" class="login-inner">
        <form @submit.prevent="login">
          <fieldset>
            <div>
              <label>
                ログインID
                <div class="common-input">
                  <input
                    v-model="mpAdminId"
                    autocomplete="mpAdminId"
                    required>
                </div>
              </label>
            </div>
            <div>
              <label>
                パスワード
                <div class="common-input">
                  <input
                    v-model="mpAdminPassword"
                    type="password"
                    autocomplete="mpAdminPassword"
                    required>
                </div>
              </label>
            </div>
            <div>
              <label>
                トークンコード
                <div class="common-input">
                  <input
                    name="token"
                    v-model="mpAdminToken"
                    type="password"
                  >
                </div>
              </label>
            </div>
          </fieldset>
          <button type="submit" class="w-b-btn">ログイン</button>
        </form>
      </div>
      <p v-if="siteExistChecked" class="link">
        <a @click="moveExtAccount">
          外部システム連携アカウントを変更する場合はこちら
        </a>
      </p>
      <small>Copyright &copy; EmberPoint Co., Ltd. All Rights Reserved.</small>
    </div>
  </div>
</template>
<script>

export default {
  data () {
    return {
      siteExistChecked: false,
      mpAdminId: '',
      mpAdminPassword: '',
      mpAdminToken: '',
      mpApiId: '',
      mpApiPassword: '',
    }
  },
  mounted () {
    const formData = new FormData()
    if (this.$route.params.mpApiId && this.$route.params.mpApiPassword) {
      // Apiアカウント設定画面から遷移した場合
      this.mpApiId = this.$route.params.mpApiId
      this.mpApiPassword = this.$route.params.mpApiPassword
      this.siteExistChecked = true
      return
    }
    formData.append('mpDomain', this.$route.params.mpDomain)
    formData.append('siteId', this.$route.params.siteId)
    this.$http({
      type: 'POST',
      url: '/pre_login',
      params: formData,
    }).then(json => {
      if (json && json.status === 200) {
        if (json.data['existExtAccount']) {
          this.siteExistChecked = true
        } else {
          this.$router.push({ name: 'extAccount' })
        }
      }
    })
  },
  methods: {
    login () {
      const formData = new FormData()
      formData.append('mpDomain', this.$route.params.mpDomain)
      formData.append('mpSiteId', this.$route.params.siteId)
      formData.append('mpAdminId', this.mpAdminId)
      formData.append('mpAdminPassword', this.mpAdminPassword)
      formData.append('mpAdminToken', this.mpAdminToken)
      formData.append('mpApiId', this.mpApiId)
      formData.append('mpApiPassword', this.mpApiPassword)
      this.$http({
        type: 'POST',
        url: '/login',
        params: formData,
      }).then(json => {
        if (json && json.status === 200) {
          this.$utils.token.set(json.data.token)
          if (this.$route.query.redirect && !this.$route.query.redirect.endsWith('/login')) {
            this.$router.push(this.$route.query.redirect)
          } else {
            this.$router.push({ name: 'contentList' })
          }
        }
      })
    },
    moveExtAccount () {
      this.$router.push({
        name: 'extAccount',
        query: {
          redirect: this.$route.query.redirect
        }
      })
    },
  }
}

</script>
<style lang="scss" scoped>
.login {
  width: 100vw;
  height: 100vh;
  background: #f8f8f8;
  position: relative;
  .login-area {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .login-inner {
      background: #fff;
      border-radius: 2px;
      box-shadow: 2px 2px 4px rgba(#484848, 0.2);
      width: 440px;
      padding: 35px;
      padding-bottom: 20px;
      box-sizing: border-box;
      h1 {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      p {
        font-size: 12px;
      }
      form {
        width: 100%;
      }
      label {
        font-size: 12px;
        margin-bottom: 0.5rem;
        width: 370px;
        display: block;
      }
      .common-input {
        padding: 0;
        width: 370px;
        input {
          padding: 8px;
          box-sizing: border-box;
        }
      }
      .w-b-btn {
        margin: 0 auto;
        display: block;
      }
    }
    .link {
      cursor: pointer;
      margin-top: 30px;
      text-align: center;
      font-size: 12px;
    }
    small {
      color: rgba($baseFontColor, 0.6);
      font-size: 10px;
      text-align: center;
      display: block;
      margin-top: 15px;
    }
  }
}
</style>
